// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3cw1X","title":"InfoRow_title__2jU2r"};